export function BellZIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 5a1 1 0 112 0c0 .25.092.48.244.655h.001l.013.016.053.063C14 6.5 15.5 6 14.974 4.605a3 3 0 00-5.948 0l-.08.097c-.18.218-.427.525-.7.88-.534.697-1.205 1.63-1.634 2.458-.473.913-.87 2.116-1.142 3.046a33.978 33.978 0 00-.377 1.407L3 14.586C1.74 15.846 2.632 18 4.414 18H8a4 4 0 008 0h3.586c1.782 0 2.674-2.154 1.414-3.414l-2.093-2.093c-1.407-1.493-2.822.006-1.614 1.214L19.586 16H4.414l2.293-2.293a.995.995 0 00.271-.498l.004-.015a14.754 14.754 0 01.102-.421c.072-.285.176-.68.306-1.126.265-.909.618-1.955.998-2.687.344-.663.923-1.48 1.445-2.16a31.828 31.828 0 01.856-1.066l.053-.063.013-.015A.996.996 0 0011 5zm1 15a2 2 0 01-2-2h4a2 2 0 01-2 2z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M18 2a1 1 0 100 2h1.865l-3.633 4.36A1 1 0 0017 10h5a1 1 0 000-2h-2.865l3.633-4.36A1 1 0 0022 2h-4z"
      ></path>
    </svg>
  );
}
